@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.voiceassistant

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantSettingsDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantTurnLogDto
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantField

object TestVoiceAssistantEngineEndpoint :
    EndPoint<TestVoiceAssistantEngineEndpoint.Request, TestVoiceAssistantEngineEndpoint.Response>() {
    class Request(
        val settings: VoiceAssistantSettingsDto,
        @Suppress("NON_EXPORTABLE_TYPE") val field: DtoName<VoiceAssistantField>,
        val typedTranscript: String?,
        val audioBase64: String?,
        val audioMimeType: String?,
    )

    class Response(val turn: VoiceAssistantTurnLogDto)
}
